import React from 'react';
import './styles.sass';

export function FooterSimple(){
    return(
        <footer>
			<p>Power by ClaroShop </p>
		</footer>
    )
}